import { addDays, format, formatISO, isWeekend } from 'date-fns';
import { COUNTRIES, TARGET_FULL_TIME_HOURS } from '../constants';
import { Activity } from '../models/activity';
import { Holiday } from '../models/holidays';
import { getDaysMonth, getDaysWeek } from './dateService';
import { ActivityFormData } from '../components/activity/activityForm';
import { generateProjectLabel } from './projectService';
import {
   formatDateOnly,
} from '../services/dateService';

export function getTotalHours(activities: Array<Activity>): number {
  return activities.reduce((prev, current) => prev + current.hours, 0);
}

export function showHoursDayWorked(hoursWorked: number): string {
  if (!hoursWorked) {
    return '';
  }

  return `${hoursWorked}/8h`;
}

export function getTotalHoursReach(
  date: Date,
  targetHolidays: Holiday[] | undefined,
  userLocation: string | null,
  viewMode: 'month' | 'week',
  employeeWorkHours: number
): number {
  const period = viewMode === 'month' ? getDaysMonth(date) : getDaysWeek(date);

  return period.reduce((prev, current) => {
    const isTargetHoliday = targetHolidays?.some(
      (holiday) =>
        format(new Date(formatDateOnly(holiday.dayOffDate)), 'PP') === format(current, 'PP')
    );
    const isNextDayHoliday = targetHolidays?.some(
      (holiday) =>
        format(new Date(formatDateOnly(holiday.dayOffDate)), 'PP') ===
        format(addDays(current, 1), 'PP')
    );

    if (isWeekend(current) || isTargetHoliday) {
      return prev;
    } else if (isNextDayHoliday && userLocation === COUNTRIES.MOLDOVA) {
      return prev + employeeWorkHours - 1;
    }

    return prev + employeeWorkHours;
  }, 0);
}

export const getTargetHoursToWork = (
  date: Date,
  targetHolidays: Holiday[] | undefined,
  userLocation: string | null,
  employeeWorkHours: number
): number => {
  const isTargetHoliday = targetHolidays?.some(
    (holiday) =>
      format(new Date(formatDateOnly(holiday.dayOffDate)), 'PP') === format(date, 'PP')
  );
  const nextDayHoliday = targetHolidays?.some(
    (holiday) =>
      format(new Date(formatDateOnly(holiday.dayOffDate)), 'PP') ===
      format(addDays(date, 1), 'PP')
  );

  if (isWeekend(date) || isTargetHoliday) {
    return employeeWorkHours;
  } else if (nextDayHoliday && userLocation === COUNTRIES.MOLDOVA) {
    return employeeWorkHours - 1;
  }

  return employeeWorkHours;
};

export const getWorkDayHolidays = (holidays: Holiday[]): Holiday[] =>
  holidays?.filter((el) => !isWeekend(new Date(formatDateOnly(el.dayOffDate))));

export const getTotalHoursDayReach = (
  dateActivity: Date,
  targetHolidays: Holiday[] | undefined,
  nextDayHoliday: Holiday[] | undefined,
  userLocation: string | null,
  employeeWorkHours: number
): number => {
  if (
    !isWeekend(dateActivity) &&
    !targetHolidays?.length &&
    nextDayHoliday?.length &&
    userLocation === COUNTRIES.MOLDOVA
  ) {
    return employeeWorkHours - 1;
  }

  return employeeWorkHours;
};

export const generateActivityFormData = (
  activity?: Activity
): ActivityFormData<string> => {
  return {
    id: activity?.id || '',
    project: activity
      ? {
        id: activity.task.project.id,
        label: generateProjectLabel(
          activity.task.project.name,
          activity.task.project.code
        ),
      }
      : null,
    task: activity ? activity.task : null,
    date: activity ? activity.date : formatISO(new Date()),
    hours: activity?.hours.toString() || '',
    comment: activity?.comment || '',
    ticketIdentification: activity?.ticketIdentification || '',
    isAMS: activity?.task.project?.isAMS || false,
  };
};
